var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#53A1D1",
    points: "36.73,22.962 24,15.613 15.846,20.323 17.642,21.362 19.433,20.328 24,17.687 29.178,20.677  34.933,24 36.757,25.055 38.705,26.177 42.899,28.594 42.899,34.908 30.103,42.297 30.103,44.374 44.691,35.944 44.691,27.561  38.558,24.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#184891",
    points: "11.271,25.034 17.926,28.875 24,32.388 32.135,27.712 32.181,27.684 30.367,26.635 28.569,27.676  24,30.311 13.071,24 11.275,22.962 5.106,19.398 5.106,13.094 6.87,12.076 17.9,5.7 17.9,3.633 3.31,12.051 3.31,20.436 9.48,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F79420",
    points: "22.635,8.808 22.441,8.917 22.635,8.808  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184891",
    d: "M24,0.106l-0.895,0.511v7.919l-0.471,0.271l-0.194,0.109l-10.771,6.221L10.6,13.685l-1.219,4.142 l4.318,0.055l-0.953-1.29L24,10.09l10.281,5.936l1.476,0.852l8.935,5.166v-2.079v-5.839v-2.075L24,0.106z M42.919,18.937 l-0.887-0.512l-2.428-1.401L24.904,8.537V2.702l16.23,9.374l1.16,0.667l0.625,0.357V18.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#53A1D1",
    d: "M38.493,30.086l-4.319-0.009l1.03,1.364l-9.439,5.448L24,37.908L3.31,25.953v1.723v0.356v5.838v1.556v0.519 L24,47.894l0.903-0.515v-7.917l11.392-6.572l1.021,1.352L38.493,30.086z M23.106,45.295L5.087,34.896v-5.838l6.262,3.619 l11.757,6.784V45.295z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#53A1D1",
    points: "17.723,38.515 17.723,40.34 18.999,41.075 18.999,39.254  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#53A1D1",
    points: "13.428,36.034 13.428,37.86 14.705,38.597 14.705,36.773  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#53A1D1",
    points: "9.134,33.556 9.134,35.38 10.411,36.117 10.411,34.293  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#184891",
    points: "37.584,12.066 37.584,13.89 38.86,14.627 38.86,12.803  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#184891",
    points: "33.29,9.585 33.29,11.411 34.565,12.149 34.565,10.322  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#184891",
    points: "28.994,7.108 28.994,8.932 30.271,9.67 30.271,7.845  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo_mark.14b7b676192495e6b9e56b78df967f5e.svg";
export { ForwardRef as ReactComponent };